export default __webpack_public_path__ + "static/media/IPAD-WITH-MIKALENE-THOMAS.b139a9c2.png";